import axios, { AxiosError } from "axios";
import { defaultHeadersWithToken } from "@/constants/constants";
import { rto_package_tracking_url } from "@/constants/urls";
import { store } from "@/store/store";

export interface RtoPackageDetail {
  sku: string;
  title: string;
  image: string;
  qte: number;
}

export interface RtoPackageTrackingData {
  status: "treated" | "pending";
  trackingCode: string;
  refCommande: string;
  tourneeId?: number;
  demandeRepriseId?: number;
  onHub: string;
  hubId?: number;
  hubName?: string;
  sellerId: number;
  sellerName: string;
  createdBy: string;
  createdAt: string;
  treatedBy?: string;
  dateTreated?: string;
  details?: RtoPackageDetail[];
}

export interface RtoPackageTrackingResponse {
  success: boolean;
  message: string | null;
  error: string | null;
  errorDescription: string | null;
  data?: RtoPackageTrackingData;
}

export const getRtoPackageTracking = async (
  trackingCode: string
): Promise<RtoPackageTrackingResponse> => {
  const accessToken = store.getState().authentication.accessToken;

  try {
    const response = await axios.get<RtoPackageTrackingResponse>(
      `${rto_package_tracking_url}${encodeURIComponent(trackingCode)}`,
      {
        headers: defaultHeadersWithToken(accessToken),
      }
    );

    return response.data;
  } catch (error: unknown) {
    const axiosError = error as AxiosError<RtoPackageTrackingResponse>;
    if (axiosError?.response?.data) {
      return axiosError.response.data;
    }

    return {
      success: false,
      message: null,
      error: "Une erreur est survenue lors de la recuperation du colis.",
      errorDescription: "",
    };
  }
};
